import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { getPublicFolderPath } from '../../../../utils';

const useStyles = makeStyles((theme: any) => ({
  logo: {
    width: ({ width }: any) => width,
  },
}));

export default function StageDetailsLogo({
  imgSrc,
  width = 8,
  altText = 'Stage detail icon',
}) {
  const classes = useStyles({ width });
  let StageDetailsLogo = getPublicFolderPath(window.location.pathname);
  StageDetailsLogo += imgSrc;

  return <img src={StageDetailsLogo} alt={altText} className={classes.logo} />;
}
